import { ModalBase, Option, Select, Typography } from '@/components'
import { paths } from '@/routes/paths'
import {
  useCreateMultipleInsurances,
  useUploadInsuranceFiles,
} from '@/services'
import { useGoToPath } from '@/utils'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext, useParams } from 'react-router-dom'
import { CarrierDropdownContainer } from './styles'

interface OutletContextType {
  carriers: Array<{
    text: string
    value: string
    icon: string
  }>
}

interface UploadContractModalProps {
  files: File[]
  onClose: () => void
}

const useMessages = () => {
  const { t } = useTranslation()
  return {
    chooseCompany: t('addInsurance.chooseCompany'),
    prompt: t('addInsurance.prompt'),
    upload: t('uploadContract'),
  }
}

export const UploadContractModal = ({
  files,
  onClose,
}: UploadContractModalProps) => {
  const { categoryId, locationId } = useParams<{
    categoryId: string
    locationId: string
  }>()
  const messages = useMessages()
  const { carriers } = useOutletContext<OutletContextType>()
  const uploadContractMutation = useUploadInsuranceFiles('')
  const createInsuranceMutation = useCreateMultipleInsurances()
  const [carrierId, setCarrierId] = useState<string>()

  const goToInsurance = useGoToPath(paths.viewInsuranceWithKey)

  const handleUploadContract = () => {
    if (!categoryId || !locationId || !carrierId) return

    createInsuranceMutation
      .mutateAsync({ locationId, data: [{ categoryId, carrierId }] })
      .then(({ created }) =>
        uploadContractMutation
          .mutateAsync({ id: created[0], files })
          .then(() => {
            goToInsurance({
              locationId,
              categoryId,
              insuranceId: created[0],
            })
          }),
      )
  }

  return (
    <ModalBase
      closable
      header={<Typography variant="h3">{messages.prompt}</Typography>}
      isOpen
      onClose={onClose}
      onPrimaryClick={handleUploadContract}
      primaryDisabled={!carrierId}
      primaryText={messages.upload}
    >
      <CarrierDropdownContainer>
        <Select
          onSelect={(value?: string) => setCarrierId(value)}
          placeholder={messages.chooseCompany}
          value={carrierId}
        >
          {carriers?.map(({ text, value, icon }) => (
            <Option key={value} icon={icon} value={value}>
              {text}
            </Option>
          ))}
        </Select>
      </CarrierDropdownContainer>
    </ModalBase>
  )
}
